/**
 * Catalog service constants
 */

import { CACHE_DURATIONS } from '@/lib/config/cache.config';

export const CACHE_DURATION = CACHE_DURATIONS.MEDIUM; // 5 minutes from centralized config

export const DEFAULT_PAGINATION = {
  PAGE: 1,
  LIMIT: 10,
} as const;

export const SORT_VALUES = {
  LATEST: '-createdDate',
  OLDEST: 'createdDate',
  TITLE_ASC: 'name',
  TITLE_DESC: '-name',
  RAND: 'rand',
  RAND_DESC: '-rand',
} as const;

export const ARTWORK_SORT_VALUES = {
  LATEST: '-artworkCreatedDate',
  OLDEST: 'artworkCreatedDate',
  TITLE_ASC: 'title',
  TITLE_DESC: '-title',
  RAND_ASC: 'rand_asc',
} as const;

export const STATUS_VALUES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
} as const;